import Color from "color";

import { ThemePlusTypes } from "@styles/types";
import { PalletThemeColors } from "@styles/utils";

export default (colors: PalletThemeColors): ThemePlusTypes["customTheme"] => {
  return {
    backgroundHover: Color(colors.primary.base).alpha(0.15).string(),
    borderColor: colors.secondary.base,
    borderColorHover: colors.primary.base,
    textSecondary: colors.secondary.dark,
    actionBlack: colors.black,
    primaryColor: colors.primary.base,
    previewBackground: colors.secondary.lighter,
    previewBackgroundHover: Color(colors.primary.darker).alpha(0.5).string(),
  };
};
